import FeatureGates from '@atlaskit/feature-gate-js-client';

export type LiteModeCohort = 'test' | 'control' | 'not-enrolled';

/**
 * Reads the user's cohort for the Confluence lite-mode experiment
 * (`rovo_ui_refresh_in_confluence_search_page_exp`) WITHOUT firing an exposure.
 *
 * The product fires the real exposure when it decides whether to render the lite
 * page (see `confluence/next/packages/advanced-search/src/SearchPage.tsx`); this
 * read is purely to stamp the cohort onto analytics events, so it must not
 * double-count exposures.
 *
 * Returns 'test' / 'control' for enrolled users and 'not-enrolled' for everyone
 * else — letting analytics tell the experiment's control arm apart from the
 * population that was never in the experiment (both render the non-lite page and
 * so both report `isLiteMode === false`).
 */
export const getLiteModeCohortWithoutExposure = (): LiteModeCohort => {
	const cohort = FeatureGates.getExperimentValue<string>(
		'rovo_ui_refresh_in_confluence_search_page_exp',
		'cohort',
		'not-enrolled',
		{ fireExperimentExposure: false },
	);

	return cohort === 'test' || cohort === 'control' ? cohort : 'not-enrolled';
};
